import { useState } from "react"

import { ParadiseHomeDeleteDialog } from "src/components/Paradise/ParadiseHomes/ParadiseHomeDetails/ParadiseHomeDeleteDialog"
import { ParadiseHomeRestoreDialog } from "src/components/Paradise/ParadiseHomes/ParadiseHomeDetails/ParadiseHomeRestoreDialog"
import { ParadiseHomeTransferDialog } from "src/components/Paradise/ParadiseHomes/ParadiseHomeDetails/ParadiseHomeTransferDialog"
import { ActionsWrapper } from "src/components/Paradise/sharedStyles"
import { RequireRoles } from "src/components/RestrictedRoles/RequireRoles"
import { IParadiseHome } from "src/data/paradise/paradiseHomes/types/paradiseHomeQuerytypes"
import { UserRoles } from "src/data/user/user"
import { DropdownListButton, IOption } from "src/ui/Button/DropdownListButton"

export function ParadiseHomeActions({ home }: { home: IParadiseHome }) {
  const [showTransferDialog, setShowTransferDialog] = useState(false)
  const [showRestoreDialog, setShowRestoreDialog] = useState(false)
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)

  const options: IOption<"transfer" | "restore" | "delete">[] = [
    {
      name: "Transfer unit",
      value: "transfer",
      onClick: () => setShowTransferDialog(true),
    },
  ]
  if (home.deleted) {
    options.push({
      name: "Restore unit",
      value: "restore",
      onClick: () => setShowRestoreDialog(true),
    })
  } else {
    options.push({
      name: "Delete unit",
      value: "delete",
      onClick: () => setShowDeleteDialog(true),
      color: "destructive",
    })
  }
  return (
    <RequireRoles roles={[UserRoles.SUPERADMIN]}>
      <ActionsWrapper>
        <DropdownListButton displayValue="Home actions" options={options} />
      </ActionsWrapper>
      <ParadiseHomeTransferDialog
        open={showTransferDialog}
        homeOwnerId={home.owner.id}
        homeName={home.name}
        homeId={home.id}
        onClose={() => setShowTransferDialog(false)}
      />
      <ParadiseHomeRestoreDialog
        open={showRestoreDialog}
        homeName={home.name}
        homeId={home.id}
        onClose={() => setShowRestoreDialog(false)}
      />
      <ParadiseHomeDeleteDialog
        open={showDeleteDialog}
        homeName={home.name}
        homeId={home.id}
        orgId={home.owner.id}
        onClose={() => setShowDeleteDialog(false)}
      />
    </RequireRoles>
  )
}
